
import { stockAPI } from './api';

export const stockActions = {
  // Get stock summary with filters
  getStockSummary: async (params = {}) => {
    try {
      const response = await stockAPI.getSummary(params);

      if (response.success) {
        return {
          success: true,
          data: response.data || [],
          total: response.total || 0,
          page: response.page || 1,
          totalPages: response.total_pages || 1
        };
      }
      
      return {
        success: false,
        message: response.message || 'Failed to fetch stock summary',
        data: []
      };
    } catch (error) {
      console.error('Error fetching stock summary:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch stock summary',
        data: []
      };
    }
  },

  // Get stock movements for a product
  getStockMovements: async (params = {}) => {
    try {
      const response = await stockAPI.getMovements(params);
      
      if (response.success) {
        return {
          success: true,
          data: response.data || [],
          total: response.total || 0,
          page: response.page || 1,
          totalPages: response.total_pages || 1
        };
      }
      
      return {
        success: false,
        message: response.message || 'Failed to fetch stock movements',
        data: []
      };
    } catch (error) {
      console.error('Error fetching stock movements:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch stock movements',
        data: []
      };
    }
  },

  // Adjust stock manually
  adjustStock: async (adjustmentData) => {
    try {
      const response = await stockAPI.adjustStock(adjustmentData);

      if (response.success) {
        return {
          success: true,
          data: response.data,
          message: response.message || 'Stock adjusted successfully'
        };
      }
      
      return {
        success: false,
        message: response.message || 'Failed to adjust stock'
      };
    } catch (error) {
      console.error('Error adjusting stock:', error);
      return {
        success: false,
        message: error.message || 'Failed to adjust stock'
      };
    }
  },

  // Get low stock alerts
  getLowStockAlerts: async () => {
    try {
      const response = await stockAPI.getLowStock();
      
      if (response.success) {
        return {
          success: true,
          data: response.data || []
        };
      }
      
      return {
        success: false,
        message: response.message || 'Failed to fetch low stock alerts',
        data: []
      };
    } catch (error) {
      console.error('Error fetching low stock alerts:', error);
      return {
        success: false,
        message: error.message || 'Failed to fetch low stock alerts',
        data: []
      };
    }
  }
};